import { OrDisclaimerText } from './or-disclaimer-text';
import { IOrDisclaimerTextCMSProps } from './or-disclaimer-text.types';

export const OrDisclaimerTextCMS = ({
  text_size,
  text,
}: IOrDisclaimerTextCMSProps) => {
  return <OrDisclaimerText textSize={text_size} text={text} />;
};
